import {
  SHOP_CATEGORIES_REQUEST,
  SHOP_CATEGORIES_SUCCESS,
  // SHOP_CATEGORIES_FAILURE,
  SHOP_CATEGORIES_CLEAR,
} from 'app/common/actions/shop/catalog/categories';


const defaultState = {
  current: {},
  children: [],
  loading: true,
};

const categories = (state = defaultState, { type, payload }) => {
  switch (type) {
    case SHOP_CATEGORIES_REQUEST: {
      return { ...state, loading: true };
    }

    case SHOP_CATEGORIES_SUCCESS: {
      return { ...state, loading: false, ...payload };
    }

    case SHOP_CATEGORIES_CLEAR: {
      return defaultState;
    }

    default:
  }
  return state;
};

export default categories;
